import React from 'react';
import { useTranslation } from 'react-i18next';
import { Page, theme, Typo, PageContainerVCenter, PageHeaderLogo, PageSection } from '../../ui';
import { CONTENT_MINI } from '../../utils/media';

const CoursioError = () => {
  const { t } = useTranslation();

  return (
    <Page backgroundColor={theme.colors.PRIMARY} fullheight={true}>
      <PageHeaderLogo />
      <PageContainerVCenter>
        <PageSection size={CONTENT_MINI}>
          <Typo.ContentSmallHeader $themeColor={theme.colors.PRIMARY}>{t('genericPages.errorPage.genericMessage')}</Typo.ContentSmallHeader>
        </PageSection>
      </PageContainerVCenter>
    </Page>
  );
};

export default CoursioError;
